import { SITE_PAGES } from 'Config';
import PropTypes from 'prop-types';
import AccountLanding from '../AccountLanding';
import AccountDetails from '../ChargeAccounts/AccountDetails';

const AccountDetailsPage = ({ accountId, accountObject, params }) => {
  let breadcrumbs = params?.id && [
    SITE_PAGES.ALL_ACCOUNTS,
    {
      icon: 'credit-card',
      text: params.id,
    },
  ];

  return (
    <AccountLanding title='Manage Account' breadcrumbs={breadcrumbs}>
      <AccountDetails
        params={params}
        accountId={accountId}
        accountObject={accountObject}
      />
    </AccountLanding>
  );
};

AccountDetailsPage.propTypes = {
  accountId: PropTypes.number,
  accountObject: PropTypes.object,
  params: PropTypes.shape({ id: PropTypes.string }),
};

export default AccountDetailsPage;
